module.exports = __webpack_public_path__ + "5d23396625be0202af36745fd13b7be8.glb";